/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CompanyInfoDto } from '../../models/company-info-dto';

export interface InfoControllerGetCompanyInfoV1$Params {
}

export function infoControllerGetCompanyInfoV1(http: HttpClient, rootUrl: string, params?: InfoControllerGetCompanyInfoV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyInfoDto>> {
  const rb = new RequestBuilder(rootUrl, infoControllerGetCompanyInfoV1.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CompanyInfoDto>;
    })
  );
}

infoControllerGetCompanyInfoV1.PATH = '/api/v1/info/company-info';
